import React from 'react';
const rows = [['Hours every week building practices from scratch', '10 minutes the night before'], ['Improvised practices with no real order', '37 practices, sequenced across the season'], ['Kids standing around waiting their turn', 'Stations so everyone is working'], ['“What do we do today?” panic at the field', 'Print today’s sheet and run it'], ['Guessing what fits your team’s age', 'Scaled for 5-6 through 13+']];
export function CostOfInaction() {
  return <section className="w-full bg-navy-deep" data-id="element-56" data-mp="38xdac2f06zy9">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20" data-id="element-57" data-mp="38wahhoy4enfp">
        <h2 className="text-center font-display font-bold uppercase text-white text-3xl sm:text-4xl" data-id="element-58" data-mp="3dnto5nmqknl5">
          What another improvised season costs you
        </h2>
        <div className="mt-8 overflow-hidden rounded-2xl border border-navy-line" data-id="element-59" data-mp="3ip98tel04s30">
          {/* So no / So yes, the product's comparison device */}
          <div className="grid grid-cols-2 text-center" data-id="element-60" data-mp="3smnovd30jeus">
            <div className="border-r border-navy-line bg-crimson px-3 py-3 font-display text-base uppercase tracking-wide text-white sm:text-lg" data-id="element-61" data-mp="3eggawanczwv5">
              So no
            </div>
            <div className="bg-green px-3 py-3 font-display text-base uppercase tracking-wide text-white sm:text-lg" data-id="element-62" data-mp="39jg6e465r265">
              So yes
            </div>
          </div>
          {rows.map(([bad, good]) => <div key={bad} className="grid grid-cols-2 border-t border-navy-line text-[12.5px] sm:text-sm" data-id="element-63" data-mp="30j1dojqv6ksm">
              <div className="border-r border-navy-line px-3.5 py-3.5 text-white/60 line-through decoration-crimson/50" data-id="element-64" data-mp="3s95xohapp5tb">
                {bad}
              </div>
              <div className="px-3.5 py-3.5 font-medium text-white" data-id="element-65" data-mp="3jfsv0nmuipu1">{good}</div>
            </div>)}
        </div>
      </div>
    </section>;
}